import { render, staticRenderFns } from "./PhieuNhapVienDetail.vue?vue&type=template&id=1be3bf5e&scoped=true"
import script from "./PhieuNhapVienDetail.vue?vue&type=script&lang=js"
export * from "./PhieuNhapVienDetail.vue?vue&type=script&lang=js"
import style0 from "./PhieuNhapVienDetail.vue?vue&type=style&index=0&id=1be3bf5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be3bf5e",
  null
  
)

export default component.exports